!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, r = {}, i = t.parcelRequire5f74;
  null == i && ((i = function(t) {
    if (t in e) return e[t].exports;
    if (t in r) {
      var i = r[t];
      delete r[t];
      var n = {
        id: t,
        exports: {}
      };
      return e[t] = n, i.call(n.exports, n, n.exports), n.exports;
    }
    var a = new Error("Cannot find module '" + t + "'");
    throw a.code = "MODULE_NOT_FOUND", a;
  }).register = function(t, e) {
    r[t] = e;
  }, t.parcelRequire5f74 = i), (0, i.register)("kmbQD", function(t, e) {
    var r, i, n, a;
    r = t.exports, i = "default", n = function() {
      return o;
    }, Object.defineProperty(r, i, {
      get: n,
      set: a,
      enumerable: !0,
      configurable: !0
    });
    class o {
      static _activeRequests=new Map;
      static _fetch(t, e = {}, r = null) {
        if (r) {
          this._activeRequests.has(r) && this._activeRequests.get(r).abort();
          const t = new AbortController;
          this._activeRequests.set(r, t), e.signal = t.signal;
        }
        return fetch(t, e).then(t => (r && this._activeRequests.delete(r), t)).catch(t => {
          throw r && "AbortError" !== t.name && this._activeRequests.delete(r), t;
        });
      }
      static doChange({id: t, quantity: e, properties: r = {}}, i = !1) {
        const n = `change-${t}`;
        return this._fetch(`${Shopify.routes.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...r
            }
          })
        }, n).then(t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && i && this.update(!0), t;
        }).catch(t => t);
      }
      static doUpdate(t, e, r = !1) {
        const i = `update-${JSON.stringify(t)}`, n = Array.isArray(t) ? t.reduce((t, r) => ({
          ...t,
          [r]: e
        }), {}) : {
          id: e
        };
        return this._fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: n
          })
        }, i).then(t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && r && this.update(!0), t;
        }).catch(t => t);
      }
      static doAdd({id: t, quantity: e, properties: r = {}}, i = !1) {
        const n = `add-${t}`;
        return this._fetch(`${Shopify.routes.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...r
              }
            } ]
          })
        }, n).then(e => {
          if (!e.ok) throw new Error("Cart add failed");
          return e.ok ? (window.dispatchEvent(new CustomEvent("product:added", {
            detail: {
              variantId: t
            }
          })), e) : e.ok && i ? (this.update(!0), e) : void 0;
        }).catch(t => t);
      }
      static getCart() {
        return this._fetch(`${Shopify.routes.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }, "get-cart").then(t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        }).catch(t => t);
      }
      static updateForm(t, e = !1) {
        return this._fetch(`${Shopify.routes.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: t
        }, "update-form").then(t => {
          if (!t.ok) throw new Error("Cart form update failed");
          return e && this.update(!0), t;
        }).catch(t => t);
      }
      static cleanupTeleportedContent() {
        document.querySelectorAll("[data-teleport-origin]").forEach(t => {
          t.remove();
        });
      }
      static update(t = !1, e = "cart-drawer", r = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("shopping-cart").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        try {
          e = e.replace("cart-notification", document.querySelector("cart-notification").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const i = document.getElementById("Cart"), n = !!t || i && i.checked;
        return fetch(`${Shopify.routes.root || "/"}?sections=${e.join(",")}`, {
          method: "GET"
        }).then(t => t.json()).then(t => {
          this.cleanupTeleportedContent(), Object.entries(t).forEach(t => {
            const [e, i] = t, a = (new DOMParser).parseFromString(i, "text/html");
            r ??= [ `[id^="shopify-section-"][id$="${e}"]` ], r.push("[data-header-cart-count]"), 
            r.forEach(t => {
              document.querySelectorAll(t).forEach(e => {
                const r = a.querySelector(t);
                r && (e.innerHTML = n ? r.innerHTML.replace('id="Cart"', 'id="Cart" checked') : r.innerHTML);
              });
            });
          });
        });
      }
    }
  });
  var n = i("kmbQD");
  class a extends HTMLElement {
    constructor() {
      super(), this.container = this.querySelector("#wishlist-items-container"), this.template = '\n      <div class="grid grid-cols-4 gap-gutter tablet:grid-cols-2">\n        {{#products}}\n        <a href="{{du}}" aria-label="{{dt}}" class="relative flex items-stretch flex-col gap-5 tablet:gap-3.5">\n          <button aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-remove-product-btn absolute cursor-pointer top-3 right-3 p-3 -m-3">\n            <svg role="presentation" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.527 5.711 11.423.816 10.607 0 5.71 4.895.816 0 0 .816 4.896 5.71 0 10.607l.816.816 4.895-4.896 4.896 4.895.816-.815z" fill="currentColor"/></svg>\n          </button>\n          <img alt="{{dt}}" class="w-full object-cover aspect-product" src="{{iu}}">\n          <div class="flex flex-col grow">\n            <div class="text-heading-sm text-scheme-links">{{dt}}</div>\n            <div class="text-heading-2xs text-scheme-links mb-2.5 tablet:mb-2">{{variantinfo}}</div>\n            <div class="text-sm text-scheme-links mb-2.5 tablet:mb-2">{{cu}}{{pr}}</div>\n            <button data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn button button--primary mt-auto">\n              {{#isInCart}}✓ Added{{/isInCart}}{{^isInCart}}Add to bag{{/isInCart}}\n            </button>\n          </div>\n        </a>\n        {{/products}}\n      </div>\n    ';
    }
    connectedCallback() {
      window.SwymCallbacks || (window.SwymCallbacks = []), window.SwymCallbacks.push(this.renderWishlist.bind(this));
    }
    getVariantInfo(t) {
      try {
        let e = t && "[]" !== t ? Object.keys(JSON.parse(t)[0]) : [], r = e.length > 0 ? e[0] : "";
        return "Default Title" === r ? "" : r;
      } catch (e) {
        return t;
      }
    }
    renderWishlist(t) {
      t.fetch(e => {
        const r = e.map(e => ((e = window.SwymUtils.formatProductPrice(e)).isInCart = t.platform.isInDeviceCart(e.epi) || e.et === t.EventTypes.addToCart, 
        e.variantinfo = e.vi ? this.getVariantInfo(e.vi) : "", e));
        this.container && (r.length > 0 ? (this.container.innerHTML = window.SwymUtils.renderTemplateString(this.template, {
          products: r
        }), this.attachClickListeners(t)) : this.container.innerHTML = "<p style='text-align:center;'>Your wishlist is currently empty.</p>");
      });
    }
    attachClickListeners(t) {
      const e = this.querySelectorAll(".swym-add-to-cart-btn"), r = this.querySelectorAll(".swym-remove-product-btn");
      e.forEach(t => t.addEventListener("click", this.onAddToCartClick.bind(this))), r.forEach(e => e.addEventListener("click", e => this.onRemoveBtnClick(e, t)));
    }
    onAddToCartClick(t) {
      t.preventDefault();
      const e = t.currentTarget, r = e.getAttribute("data-variant-id"), i = e.innerHTML, a = window.strings || {};
      e.innerHTML = a.adding || "Adding...", n.default.doAdd({
        id: parseInt(r, 10),
        quantity: 1
      }, !0).then(t => {
        t && t.ok ? (e.innerHTML = a.added || "Added", e.setAttribute("data-state-cart", "swym-added")) : (e.innerHTML = a.error || "Error", 
        setTimeout(() => e.innerHTML = i, 2e3));
      }).catch(t => {
        console.error(t), e.innerHTML = a.error || "Error", setTimeout(() => e.innerHTML = i, 2e3);
      });
    }
    onRemoveBtnClick(t, e) {
      t.preventDefault();
      const r = t.currentTarget, i = +r.getAttribute("data-variant-id"), n = +r.getAttribute("data-product-id");
      e.fetch(t => {
        t.forEach(t => {
          i && n && t.epi === i && t.empi === n && e.removeFromWishList(t, () => {
            this.renderWishlist(e);
          });
        });
      });
    }
  }
  customElements.get("swym-wishlist") || customElements.define("swym-wishlist", a);
}();